// Share, handoff and status links. The secret's key and the sender token only ever
// live in the #fragment, which browsers never send to any server
// (docs/crypto-spec.md §3.1). Never log these URLs.

/** `/s/<id>#<linkKey>`: the link the sender shares. */
export const buildSecretLink = (origin: string, id: string, linkKey: string): string => `${origin}/s/${id}#${linkKey}`;

/** `/h/<roomId>#<roomKey>`: a live handoff (docs/crypto-spec.md §5.1). */
export const buildHandoffLink = (origin: string, roomId: string, roomKey: string): string => `${origin}/h/${roomId}#${roomKey}`;

/** `/f/<roomId>#<roomKey>`: a live file transfer (docs/crypto-spec.md §6.1). */
export const buildFilesLink = (origin: string, roomId: string, roomKey: string): string => `${origin}/f/${roomId}#${roomKey}`;

/** A stored file drop (docs/adr/0015): the key rides in the fragment, as everywhere else. */
export const buildDropLink = (origin: string, dropId: string, linkKey: string): string => `${origin}/d/${dropId}#${linkKey}`;

/** `/drop-status/<id>#<senderToken>`: a stored drop's private status and delete link (docs/adr/0015). */
export const buildDropStatusLink = (origin: string, id: string, senderToken: string): string => `${origin}/drop-status/${id}#${senderToken}`;

/** `/status/<id>#<senderToken>`: the sender's private read-receipt and delete link. */
export const buildStatusLink = (origin: string, id: string, senderToken: string): string => `${origin}/status/${id}#${senderToken}`;

/** The fragment without its `#`, or null when there isn't one. */
export const readFragment = (hash: string): string | null => {
  const value = hash.startsWith('#') ? hash.slice(1) : hash;
  return value.length > 0 ? value : null;
};

/**
 * Remove the fragment from the address bar and this history entry, so the
 * key isn't left behind once it has been used.
 */
export const forgetFragment = (): void => {
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
};
